export const MINIMAL_HEADER_HEIGHT = 60;

export const MINIMAL_HEADER_HEIGHT_MOBILE = 50;
